import {
  PolicyContainer,
  PolicyTitle,
  PolicyVersion,
  PolicyText,
  PolicySectionTitle,
  PolicyArticleTitle,
  PolicyHyphenList,
} from "styles/PolicyCommon";
import { useEffect } from "react";

const OperationEn = () => {
  useEffect(() => {
    document.documentElement.lang = "en";
    document.title = "pregnancy&baby";
    return () => {
      document.documentElement.lang = "en";
      document.title = "pregnancy&baby";
    };
  }, []);

  return (
    <PolicyContainer>
      <h1 className="hide">pregnancy&amp;baby</h1>
      <PolicyTitle>pregnancy&baby Community Guidelines</PolicyTitle>
      <PolicyVersion>
        Effective Date: September 21, 2026
        <br />
        Last Updated: August 25, 2026
      </PolicyVersion>

      <PolicyText>
        These Community Guidelines (“Guidelines”) set out the rules and
        standards for using the community features provided through{" "}
        <strong>pregnancy&baby</strong>, a service operated by Connecti Co.,
        Ltd. (“Company,” “we,” “us,” or “our”).
      </PolicyText>
      <PolicyText>
        Our community is a space where users can share experiences, concerns,
        questions, and information related to pregnancy preparation, fertility
        treatment, pregnancy, childbirth, parenting, and other topics.
      </PolicyText>
      <PolicyText>
        We want pregnancy&baby to be a safe and respectful space where users can
        communicate openly and support one another. Please read and follow these
        Guidelines when using community features.
      </PolicyText>
      <PolicyText>
        These Guidelines supplement the{" "}
        <strong>pregnancy&baby Terms of Use</strong>. If your activity violates
        applicable laws, the Terms of Use, or these Guidelines, we may take
        appropriate action, including restricting content or your use of
        community features.
      </PolicyText>
      <PolicyText>
        We may update these Guidelines when necessary to maintain a safe and
        healthy community. Material changes will be announced in advance through
        the Service in accordance with the Terms of Use and applicable law.
      </PolicyText>

      <PolicySectionTitle>1. Your Profile Represents You</PolicySectionTitle>
      <PolicyText>
        Your nickname and profile image help other users recognize you in the
        community.
      </PolicyText>
      <PolicyText>
        Please choose profile information that appropriately represents you.
      </PolicyText>
      <PolicyText>Your profile may be restricted or changed if it:</PolicyText>
      <PolicyHyphenList>
        <li>
          Contains inappropriate, offensive, obscene, or unlawful content;{" "}
        </li>
        <li>
          Uses another person’s or organization’s name, trademark, logo, image,
          or other protected material without authorization;{" "}
        </li>
        <li>
          Impersonates another person, company, organization, pregnancy&baby
          staff member, or administrator; or{" "}
        </li>
        <li>Is otherwise likely to mislead or confuse other users.</li>
      </PolicyHyphenList>

      <PolicySectionTitle>2. Posting in the Community</PolicySectionTitle>
      <PolicyText>
        Content posted in the pregnancy&baby community may be visible to other
        members.
      </PolicyText>
      <PolicyText>
        Before posting, please consider whether your post or comment contains
        personal or sensitive information that you do not wish to share with
        others.
      </PolicyText>
      <PolicyText>
        All posts, comments, profile information, images, and other content must
        comply with these Guidelines and the pregnancy&baby Terms of Use.
      </PolicyText>

      <PolicySectionTitle>
        3. Reporting Inappropriate Content
      </PolicySectionTitle>
      <PolicyText>
        If you encounter a post or comment that you believe violates these
        Guidelines—for example, spam, unauthorized advertising, harassment,
        abusive language, or other inappropriate content—you may report it using
        the reporting feature available in the Service.
      </PolicyText>
      <PolicyText>
        Reports help us maintain a safer and more respectful community.
      </PolicyText>
      <PolicyText>
        We may review reported content and take appropriate action based on
        these Guidelines, the Terms of Use, and applicable law.
      </PolicyText>

      <PolicySectionTitle>4. Content That Is Not Allowed</PolicySectionTitle>
      <PolicyText>
        The following types of content are prohibited in the pregnancy&baby
        community.
      </PolicyText>
      <PolicyArticleTitle>4.1 Sexual or Obscene Content</PolicyArticleTitle>
      <PolicyText>Do not post content that:</PolicyText>
      <PolicyHyphenList>
        <li>
          Contains excessively explicit sexual or obscene descriptions or
          imagery;{" "}
        </li>
        <li>
          Promotes, solicits, or facilitates prostitution or illegal sexual
          services;{" "}
        </li>
        <li>
          Is intended to sexually humiliate, harass, or offend another person;
          or{" "}
        </li>
        <li>Contains sexual exploitation or other unlawful sexual content.</li>
      </PolicyHyphenList>

      <PolicyArticleTitle>
        4.2 Illegal Activities or Transactions
      </PolicyArticleTitle>
      <PolicyText>Do not use the community to:</PolicyText>
      <PolicyHyphenList>
        <li>Promote or facilitate illegal gambling; </li>
        <li>
          Sell, purchase, exchange, or solicit illegal goods or services;{" "}
        </li>
        <li>
          Sell or promote products that are prohibited from being sold online
          under applicable law; or{" "}
        </li>
        <li>
          Provide information intended to encourage, facilitate, or assist
          illegal activities.
        </li>
      </PolicyHyphenList>

      <PolicyArticleTitle>4.3 Harmful or Disturbing Content</PolicyArticleTitle>
      <PolicyText>Do not post content that:</PolicyText>
      <PolicyHyphenList>
        <li>
          Contains excessively graphic, gruesome, or disturbing images or
          descriptions, including severely injured bodies or explicit depictions
          of death;{" "}
        </li>
        <li>Contains or facilitates sexual exploitation; </li>
        <li>
          Threatens, coerces, or entices another person for purposes of sexual
          exploitation;{" "}
        </li>
        <li>Encourages or glorifies violence; </li>
        <li>
          Promotes discrimination, hatred, or prejudice against a person or
          group based on characteristics such as nationality, region of origin,
          race, appearance, disability, illness, sex, gender identity, sexual
          orientation, or other protected or identity-related characteristics;
          or{" "}
        </li>
        <li>Encourages, assists, or promotes suicide or group suicide.</li>
      </PolicyHyphenList>

      <PolicyArticleTitle>
        4.4 Advertising and Promotional Content
      </PolicyArticleTitle>
      <PolicyText>
        Unauthorized commercial advertising, promotional activities,
        solicitation, and spam may be restricted or removed.
      </PolicyText>
      <PolicyText>
        This may include repetitive promotional posts, advertisements posted
        primarily for commercial purposes, or content intended to redirect users
        to unauthorized commercial activities.
      </PolicyText>
      <PolicyText>
        The Company does not participate in or guarantee transactions
        voluntarily conducted between users as a result of posts or interactions
        within the community.
      </PolicyText>
      <PolicyText>
        If you encounter suspicious commercial or promotional activity, please
        report it through the Service.
      </PolicyText>

      <PolicyArticleTitle>
        4.5 Harassment, Abuse, Defamation, and Impersonation
      </PolicyArticleTitle>
      <PolicyText>Do not:</PolicyText>
      <PolicyHyphenList>
        <li>Repeatedly insult, threaten, harass, or abuse another person; </li>
        <li>
          Use excessively abusive, degrading, or offensive language directed at
          another user;{" "}
        </li>
        <li>
          Impersonate pregnancy&baby, the Company, its employees or
          administrators, or another person;{" "}
        </li>
        <li>
          Misrepresent yourself in order to deceive other users or obtain an
          improper benefit;{" "}
        </li>
        <li>
          Deliberately spread false or misleading information about another
          person or organization in a manner that may cause harm; or{" "}
        </li>
        <li>
          Publish fabricated content presented as legitimate news or reporting
          in a manner likely to mislead users.
        </li>
      </PolicyHyphenList>

      <PolicyArticleTitle>
        4.6 Malicious Software and Interference with the Service
      </PolicyArticleTitle>
      <PolicyText>Do not:</PolicyText>
      <PolicyHyphenList>
        <li>
          Upload, distribute, or link to viruses, malware, malicious code, or
          other software intended to damage or interfere with devices or
          systems;{" "}
        </li>
        <li>
          Attempt to interfere with or disrupt the normal operation of
          pregnancy&baby;{" "}
        </li>
        <li>Exploit vulnerabilities in the Service; or </li>
        <li>
          Use automated or unauthorized methods to distribute advertisements,
          promotions, friend requests, engagement requests, or similar content.
        </li>
      </PolicyHyphenList>

      <PolicyArticleTitle>
        4.7 Intellectual Property Infringement
      </PolicyArticleTitle>
      <PolicyText>
        Respect the intellectual property rights of others.
      </PolicyText>
      <PolicyText>Do not:</PolicyText>
      <PolicyHyphenList>
        <li>
          Use another person’s copyrighted work, trademark, design, image, or
          other protected material without authorization;{" "}
        </li>
        <li>
          Share copyrighted broadcasts, music, films, animations, photographs,
          images, articles, posts, or other works without appropriate
          permission;{" "}
        </li>
        <li>
          Provide instructions or information intended to facilitate unlawful
          access to copyrighted material; or{" "}
        </li>
        <li>
          Copy or repost another pregnancy&baby user's posts, photographs, or
          images without permission where such use infringes their rights.
        </li>
      </PolicyHyphenList>

      <PolicyArticleTitle>
        4.8 Personal Information and Moving Conversations Outside the Service
      </PolicyArticleTitle>
      <PolicyText>
        To help protect users’ privacy and safety, do not:
      </PolicyText>
      <PolicyHyphenList>
        <li>
          Request another user’s personal information through posts or
          comments;{" "}
        </li>
        <li>
          Publicly post personal information that could expose yourself or
          another person to privacy or safety risks; or{" "}
        </li>
        <li>
          Repeatedly or inappropriately encourage users to move conversations to
          external social media accounts, messaging services, or other
          off-platform channels.
        </li>
      </PolicyHyphenList>
      <PolicyText>
        When sharing information in the community, please remember that other
        members may be able to view it.
      </PolicyText>

      <PolicyArticleTitle>
        4.9 Spam and Other Disruptive Behavior
      </PolicyArticleTitle>
      <PolicyText>Do not:</PolicyText>
      <PolicyHyphenList>
        <li>Repeatedly post identical or substantially similar content; </li>
        <li>Spam multiple areas of the Service; </li>
        <li>Manipulate or misuse Service features; </li>
        <li>
          Deliberately interfere with other users’ ability to use the Service;
          or{" "}
        </li>
        <li>
          Engage in other behavior that materially disrupts the normal operation
          of the community.
        </li>
      </PolicyHyphenList>
      <PolicyText>
        Conduct not expressly listed in these Guidelines may also be restricted
        if it clearly undermines the safety, integrity, or normal operation of
        the Service or significantly interferes with other users’ use of the
        Service.
      </PolicyText>

      <PolicySectionTitle>5. Content Moderation</PolicySectionTitle>
      <PolicyText>
        If content violates applicable law, the pregnancy&baby Terms of Use, or
        these Guidelines, we may take measures including:
      </PolicyText>
      <PolicyHyphenList>
        <li>Limiting the visibility of the content; </li>
        <li>Temporarily hiding the content; </li>
        <li>Removing the content; </li>
        <li>Restricting posting or commenting features; </li>
        <li>Restricting access to certain community features; or </li>
        <li>
          Taking other measures reasonably necessary to prevent continued
          violations or harm.{" "}
        </li>
      </PolicyHyphenList>
      <PolicyText>
        The Company is not required to review all user content before it is
        posted.
      </PolicyText>
      <PolicyText>
        The fact that particular content remains visible does not mean that the
        Company has approved, endorsed, or verified that content.
      </PolicyText>

      <PolicySectionTitle>
        6. Account and Service Restrictions
      </PolicySectionTitle>
      <PolicyText>
        If a user violates applicable law, the Terms of Use, or these
        Guidelines, we may restrict the user's access to certain features or
        Services.
      </PolicyText>
      <PolicyText>
        Depending on the nature, severity, and frequency of the violation,
        restrictions may be temporary or permanent.
      </PolicyText>
      <PolicyText>Measures may include:</PolicyText>
      <PolicyHyphenList>
        <li>Warning the user; </li>
        <li>Limiting the visibility of content; </li>
        <li>Removing content; </li>
        <li>Temporarily restricting posting or commenting; </li>
        <li>Restricting access to community features; </li>
        <li>Temporarily suspending the Account; or </li>
        <li>Permanently restricting the Account in serious cases.</li>
      </PolicyHyphenList>
      <PolicyText>
        We may take immediate action without applying progressive restrictions
        where reasonably necessary, including in cases involving serious illegal
        activity, sexual exploitation, illegal gambling, significant safety
        risks, malicious attacks on the Service, or other serious violations.
      </PolicyText>
      <PolicyText>
        We may also take reasonable protective measures if abnormal Account
        activity, unauthorized access attempts, automated abuse, or other
        activity that may threaten users or the Service is detected.
      </PolicyText>

      <PolicySectionTitle>7. Appeals</PolicySectionTitle>
      <PolicyText>
        If you believe that your content or Account was restricted in error, you
        may contact pregnancy&baby Customer Support and request a review.
      </PolicyText>
      <PolicyText>
        We will review the request in accordance with these Guidelines, the
        Terms of Use, and applicable law.
      </PolicyText>
      <PolicyText>
        <strong>Customer Support</strong>: after10month@connect-i.co.kr
      </PolicyText>

      <PolicySectionTitle>
        8. Relationship with the Terms of Use
      </PolicySectionTitle>
      <PolicyText>
        These Guidelines form part of the rules governing the use of
        pregnancy&baby and should be read together with the{" "}
        <strong>pregnancy&baby Terms of Use</strong>.
      </PolicyText>
      <PolicyText>
        If a matter is not specifically addressed in these Guidelines, it will
        be handled in accordance with the Terms of Use, applicable law, and
        other applicable policies of the Company.
      </PolicyText>
    </PolicyContainer>
  );
};

export default OperationEn;
